import urlResolver from 'admin/utils/URLResolver';
import useSWR from 'swr';
import { Question } from 'edrolo/domains/coursePortal/types/Task';

export const useQuestion = (questionId: QuestionId) => {
  const questionUrl = urlResolver.reverse('api:get:exam-questions', {
    questionId,
  });

  const { data, error, isLoading } = useSWR<Question>(questionUrl);

  return {
    data,
    error,
    isLoading,
  };
};
